/* unplugin-vue-components disabled */import { render } from "./VideoComponent.vue?vue&type=template&id=cdcd98e2&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=cdcd98e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdcd98e2"]])

export default __exports__